import { render, staticRenderFns } from "./TopSearchbar.vue?vue&type=template&id=04a16cf9"
import script from "./TopSearchbar.vue?vue&type=script&lang=js"
export * from "./TopSearchbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports